import { pagination } from "./state";

export default {
  setFetching: (state, payload) => {
    state.fetching = payload;
  },
  setCashWithdraw: (state, payload) => {
    state.cashWithdraw = payload;
  },
  setResponse: (state, payload) => {
    state.response = payload;
  },
  setLastWithdraw: (state, payload) => {
    state.lastWithdraw = payload;
  },
  setTotalWithdraw: (state, { total }) => {
    state.totalWithdraw = total;
  },
  setDataAfiliasi: (state, { linkReferral, saldo }) => {
    state.afiliasiSet.saldo = saldo;
    state.afiliasiSet.referalLink = linkReferral;
  },
  setDataRekening: (state, { id, namaBank, noRekening, pemilik }) => {
    state.afiliasiSet.rekening = {
      id,
      namaBank,
      noRekening,
      pemilik,
    };
  },
  setListBank: (state, payload) => {
    state.listBank = payload;
  },
  setDataAfiliated: (state, { totalTeman, totalOutlet }) => {
    state.afiliasiSet.afiliated = {
      totalTeman,
      totalOutlet,
    };
  },
  setDetailOwner: (state, payload) => {
    state.detailOwner = payload;
  },
  setLoadMore: (state, payload) => {
    state.loadMore = payload;
  },
  updateMutasiSaldo: (state, { data }) => {
    state.mutasiSaldo = state.mutasiSaldo.concat(data);
  },
  updateAfiliated: (state, { data }) => {
    state.afiliated = state.afiliated.concat(data);
  },
  setAfiliatedTotal: (state, { totalData }) => {
    state.afiliatedTotal = totalData;
  },
  updateWithdrawHistory: (state, { data }) => {
    state.withdrawHistory = state.withdrawHistory.concat(data);
  },
  setWithdrawHistoryTotal: (state, { totalData }) => {
    state.withdrawHistoryTotal = totalData;
  },
  setNextPagination: (state, { data, type }) => {
    state.pagination.length = data.length + state[type].length;
    state.pagination.pageNumber++;
    state.pagination.offset = state.pagination.pageNumber * state.pagination.limit;
  },
  resetPagination: (state) => {
    state.pagination = pagination();
  },
  resetWithdrawHistory: (state) => {
    state.withdrawHistory = [];
    state.withdrawHistoryTotal = 0;
  },
  resetAfiliated:(state) => {
    state.afiliated = [];
  },
  resetMutasiSaldo: (state) => {
    state.mutasiSaldo = [];
  },
};
